import { tr } from "@/i18n/copy";
import { useEffect, useState } from "react";
import { clientAppPresentation, browserMediaUrl, clientInstallIconUrl } from "@/studioBranding";
import { cachedBrandHome } from "@/brandHome";

export default function useClientAppIdentity(studio) {
  const [homeVersion,setHomeVersion]=useState(0);
  useEffect(()=>{const changed=()=>setHomeVersion(n=>n+1);window.addEventListener('tps:brand-home-changed',changed);return()=>window.removeEventListener('tps:brand-home-changed',changed);},[]);
  useEffect(() => {
    if (!studio) return undefined;
    const dynamicBranding = clientAppPresentation(studio);
    const dynamicClientApp = dynamicBranding;
    const previousTitle = document.title;
    const manifestLink = document.querySelector('link[rel="manifest"]');
    const previousManifest = manifestLink?.getAttribute("href") || document.documentElement.dataset.tpsInstallManifest || "/tps-install-v4.webmanifest";
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const previousTheme = themeMeta?.getAttribute("content") || "";
    let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const createdAppleTitle = !appleTitle;
    if (!appleTitle) {
      appleTitle = document.createElement("meta");
      appleTitle.setAttribute("name", "apple-mobile-web-app-title");
      document.head.appendChild(appleTitle);
    }
    const previousAppleTitle = appleTitle.getAttribute("content") || "";
    let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const createdAppleIcon = !appleIcon;
    if (!appleIcon) {
      appleIcon = document.createElement("link");
      appleIcon.setAttribute("rel", "apple-touch-icon");
      document.head.appendChild(appleIcon);
    }
    const previousAppleIcon = appleIcon.getAttribute("href") || "";
    const appName = studio.brand_network?.name || studio.name || tr("Studio");
    const logo = clientInstallIconUrl((studio.brand_logo_url ? browserMediaUrl(studio.brand_logo_url) : "") || dynamicClientApp.public_logo_url || "");
    document.title = appName;
    appleTitle.setAttribute("content", appName);
    if (themeMeta) themeMeta.setAttribute("content", dynamicBranding.primary_color || "#E10600");
    if (logo) appleIcon.setAttribute("href", logo);
    else appleIcon.removeAttribute("href");
    appleIcon.setAttribute("sizes", "180x180");
    appleIcon.setAttribute("type", "image/png");

    // An HTTP manifest can be fetched by the OS installation process too.
    const brandSlug=studio.brand_network?.slug;
    const homeSlug=brandSlug?(cachedBrandHome(brandSlug)||(studio.slug!==brandSlug?studio.slug:'')):'';
    const manifestUrl = browserMediaUrl(brandSlug ? `/api/brand/public/${encodeURIComponent(brandSlug)}/manifest.webmanifest${homeSlug?`?studio=${encodeURIComponent(homeSlug)}`:''}` : `/api/public/studios/${encodeURIComponent(studio.slug)}/manifest.webmanifest`);
    manifestLink?.setAttribute("href", manifestUrl);
    // Seed the next HTML load before Safari evaluates Home Screen metadata.
    try {
      const identity=JSON.stringify({name:appName, logo, color:dynamicBranding.primary_color,brand_slug:brandSlug||''});
      window.localStorage.setItem(`tps:client-identity:${studio.slug}`, identity);
      if(brandSlug)window.localStorage.setItem(`tps:client-identity:${brandSlug}`,identity);
      if(studio.slug!==brandSlug)window.localStorage.setItem("tps:client-identity:last", studio.slug);
    } catch { /* Web Storage may be unavailable in private browsing. */ }
    if (/^\/client(?:\/|$)/.test(window.location.pathname)) {
      const url = new URL(window.location.href);
      url.searchParams.set("studio", studio.slug);
      if(brandSlug)url.searchParams.set('brand',brandSlug);else url.searchParams.delete('brand');
      window.history.replaceState(window.history.state, "", url);
    }


    return () => {
      document.title = previousTitle;
      manifestLink?.setAttribute("href", previousManifest);
      if (themeMeta) themeMeta.setAttribute("content", previousTheme || "#E10600");
      if (createdAppleTitle) appleTitle.remove();
      else appleTitle.setAttribute("content", previousAppleTitle);
      if (createdAppleIcon) appleIcon.remove();
      else appleIcon.setAttribute("href", previousAppleIcon);
    };
  }, [studio,homeVersion]);
}

